<template>
  <v-container v-if="allFinalExamsCalendars2" style="background-color: white;" fluid>
    <span v-if="allFinalExamsCalendars2">
      <span class="blue--text">Шалгалтын тоо</span>:
      {{ allFinalExamsCalendars2.length }}</span
    >, {{ $attrs.selectedClassGroup.STUDENT_GROUP_NAME }}
    <v-simple-table>
      <thead>
        <tr>
          <th class="text-left" style="width: 1%">№.</th>
          <th class="text-left">Хичээл</th>
          <th
            v-for="(exam, examIndex) in allFinalExamsCalendars2"
            :key="examIndex"
          >
            {{ exam.name2 }}
          </th>
        </tr>
      </thead>
      <tbody v-if="$attrs.classStudents">
        <tr v-for="(student, index) in $attrs.classStudents" :key="index">
          <td>{{ student.index }}</td>
          <td style="width: 14%">
            {{ student.name }} /{{ student.REGISTER }}/
          </td>
          <td
            v-for="(exam, examIndex) in allFinalExamsCalendars2"
            :key="examIndex"
          >
            {{ _getScore(exam, student) }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
export default {
  data() {
    return { renderComponent: true, allFinalExamsCalendars2: null };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  methods: {
    _getScore(exam, student) {
      var sss = null;
      if (exam.students) {
        sss = exam.students.find(
          (ss) => String(ss.PERSON_ID) == String(student.PERSON_ID)
        );
      }
      return sss ? sss.score : null;
    },
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
  },
  created() {
    var examRef = this.userData.school.ref
      .collection("stateExams-2025")
      .doc(
        "classGroupId-" +
          String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
      )
      .collection("exams");
    examRef.get().then((docs) => {
      this.allFinalExamsCalendars2 = [];
      docs.forEach((doc) => {
        let exam = doc.data();
        exam.id = doc.id;
        exam.ref = doc.ref;
        exam.name2 = exam.EXAM_NAME.replace(this.$attrs.selectedClassGroup['ACADEMIC_LEVEL']+"-р ангийн", "");
        exam.students = null;
        exam.ref
          .collection("students")
          .orderBy("FIRST_NAME", "asc")
          .onSnapshot((docs) => {
            exam.students = [];
            docs.forEach((doc) => {
              let student = doc.data();
              student.id = doc.id;
              student.ref = doc.ref;
              exam.students.push(student);
            });
          });
        this.allFinalExamsCalendars2.push(exam);
      });
      this.loading = false;
    });
  },
};
</script>
